export default __webpack_public_path__ + "static/media/bg_pricing5.93e34686.svg";